import localiza from './localiza.png';
import movida from './movida.png';
import unidas from './unidas.png';

/** Uma logo do banco interno: o asset aparado (sem padding nem fundo) e o
 *  tamanho em que ele entra na caixa de 72×22. */
export type RentalCompanyLogo = { src: string; width: number; height: number };

/**
 * O banco interno de logos das locadoras (#5125), pelo CÓDIGO da locadora
 * (`rental.id`, o mesmo `id` das facetas e do filtro) — nunca pelo nome, que
 * vem com a filial ("Localiza - Congonhas"). A logo do fornecedor
 * (`rental.image`) é um JPEG com fundo e dá 404 para a maioria; o banco vem
 * antes dela.
 *
 * Os tamanhos são de ÁREA visual constante (~1.000 px²) na proporção nativa,
 * não de altura igual: com a mesma altura, o wordmark largo parece menor. Os
 * PNGs são a imagem-fonte dos componentes "Logo agência / *" do Figma (seção
 * "Aluguel de Carro (Mobile)") reduzida a 3× — o export do componente vem
 * com fundo opaco.
 *
 * Só entram os códigos confirmados no rental-car-api (`lib/enum/car.rental`):
 * o Figma desenha também Hertz, Avis, Alamo e Payless, mas sem código
 * conhecido eles seguem na logo do fornecedor ou no chip de texto.
 */
const LOGOS: Readonly<Record<string, RentalCompanyLogo>> = {
  LL: { src: localiza, width: 72, height: 14 },
  MO: { src: movida, width: 57, height: 18 },
  UN: { src: unidas, width: 58, height: 17 },
};

export function rentalCompanyLogoOf(code: string | undefined): RentalCompanyLogo | undefined {
  return code ? LOGOS[code.toUpperCase()] : undefined;
}
